<template>
  <div class="role-edit">
    <div>
      <h3>角色</h3>
      <span v-if="role">{{ role.name }}</span>
    </div>

    <div class="menu-list">
      <h3>菜单</h3>
      <el-table
        ref="menuTable"
        :data="menus"
        style="width: 100%;"
        row-key="id"
        default-expand-all
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >
        <el-table-column
          type="selection"
          width="55"
        >
          <template slot-scope="scope">
            <el-checkbox
              :checked="scope.row.selection"
              disabled
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="菜单名"
          width="180"
        />
        <el-table-column
          prop="code"
          label="菜单编码"
        />
      </el-table>
    </div>

    <div class="permission-list">
      <h3>权限</h3>
      <el-table
        ref="permissionTable"
        :data="permissions"
        style="width: 100%;"
        tooltip-effect="dark"
      >
        <el-table-column
          type="selection"
          width="55"
        >
          <template slot-scope="scope">
            <el-checkbox
              :checked="scope.row.selection"
              disabled
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="权限名"
          width="180"
        />
        <el-table-column
          prop="code"
          label="权限编码"
          width="180"
        />
        <el-table-column
          prop="router"
          label="后端路由"
        />
      </el-table>
    </div>

    <div class="footer">
      <el-button
        size="small"
        @click="$router.back()"
      >
        返回
      </el-button>
    </div>
  </div>
</template>
<style lang="less">
.role-edit {
  .footer {
    margin-top: 20px;
  }
}
</style>
<script>
const debug = require('debug')('ccs:ctrl:role_edit');
import { flat } from '../utils';
import axios from 'axios';

export default {
	data() {
		return {
			roleId: null, //
			role: null,
			menus: [], // 所有的菜单
			permissions: [], // 所有权限
			menuSelection: [], // 选择的菜单
			permissionSelection: [] // 选择的权限
		};
	},
	async created() {
		await this.init();
	},
	methods: {
		async init() {
			const { roleId } = this.$route.params;

			const [role, menus, permissions] = await Promise.all([
				axios.get(`/api/roles/${roleId}`),
				axios.get('/api/menus'),
				axios.get('/api/permissions')
			]);

			this.roleId = roleId;
			this.role = role;
			this.menus = menus;
			this.permissions = permissions;

			const flatMenus = [];
			flat(menus, flatMenus, 'children');

			// 初始化勾选
			this.role.menus.forEach(row1 => {
				flatMenus.forEach(row => {
					if (row1.id === row.id) {
						row.selection = true;
					}
				});
			});

			this.role.permissions.forEach(row1 => {
				this.permissions.forEach(row => {
					if (row1.id === row.id) {
						row.selection = true;
					}
				});
			});
		}
	}
};
</script>